import api from 'api'
import type {
  Category,
  VerificationType,
} from 'api/company/position/requirement/types'

type RequirementQuestion = {
  evaluationCriteria: string
  id: number
  idealAnswer: string
  question: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

type RequirementDetail = {
  category: Category
  company: {
    id: number
    name: string
  } | null
  description: string | null
  id: number
  isWorkerVisible: boolean
  name: string
  questions: RequirementQuestion[]
  verificationType: VerificationType
  createdAt: string
  updatedAt: string
}

export const getRequirementById = async (
  requirementId: number
): Promise<RequirementDetail> => {
  const response = await api.get<RequirementDetail>(
    `/admin/requirement/${requirementId}`
  )
  return response.data
}
